import PropTypes from 'prop-types';
import Modal from '../../../../components/Modal';

const VocabularyDetailModal = ({ 
  isOpen,
  onClose,
  data,
  selectedVocabularies,
  onRemove
}) => {

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      titleName='Vocabulary Details'
      contentWidth='75%'>
      <div className='p-4'>
        <div className='align-items-center box-border d-flex justify-content-between overflow-hidden p-3 rounded-4' >
          <div>
            <div>{`Course: ${data.courseName}`}</div>
            <div>{`Topic: ${data.topicName}`}</div>
          </div>
          <div><strong>{`ID: ${data.questionId}`}</strong></div>
        </div>
        <>
          {data.vocabulary &&
                <>
                  <div className='mt-4 mb-1 fw-bold'>Vocabulary</div>
                  <div dangerouslySetInnerHTML={{ __html: data.vocabulary }}></div>
                </>
          }

          {data.definition &&
            <>
              <div className='mt-4 mb-1 fw-bold'>Definition</div>
              <div dangerouslySetInnerHTML={{ __html: data.definition }}></div>
            </>
          }
        </>
        {selectedVocabularies.some(vocabulary => vocabulary.questionId === data.questionId) &&
        <div className='d-flex justify-content-end w-100'>
          <button className='btn btn-castleRed mt-4' onClick={() => {onRemove(data.questionId); onClose();}}>Remove Vocabulary</button>
        </div>
        }
      </div>
    </Modal>
  );
};

VocabularyDetailModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.object,
  selectedVocabularies: PropTypes.array,
  onRemove: PropTypes.func
};

export default VocabularyDetailModal;